import MaterialReactTable from "material-react-table";
import { useState } from "react";
import {
  EmptyPaper,
  LoadingError,
  LoadingPaper,
} from "../../LoadingComponents";
import { Box, Dialog, IconButton, MenuItem } from "@mui/material";
import { Visibility as ViewIcon } from "@mui/icons-material";
import { useGetPatientReports } from "../useReportQueries";
import { ecgColumns, commonColumns } from "./TabsColumns";
import ECGReport from "../ViewReport/ECGReport";

function ECGTab({ patient_id }) {
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 20 });
  const dataQuery = useGetPatientReports(patient_id, 2, {
    page: pagination.pageIndex + 1,
    per_page: pagination.pageSize,
  });

  // === ViewReport modal handling ===
  const [openViewReport, setOpenViewReport] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);

  const handleOpenViewReport = (report_id) => {
    setSelectedReport(report_id);
    setOpenViewReport(true);
  };
  const handleCloseViewReport = () => {
    setOpenViewReport(false);
  };

  let tableColumns = [...commonColumns, ...ecgColumns];

  return (
    <main
      style={{
        width: "100%",
      }}
    >
      <Dialog open={openViewReport} fullScreen>
        <ECGReport
          patient_id={patient_id}
          closeModal={handleCloseViewReport}
          report_id={selectedReport}
        />
      </Dialog>

      {dataQuery.isLoading ? (
        <LoadingPaper />
      ) : dataQuery.isError ? (
        <LoadingError error={dataQuery.error} />
      ) : (
        dataQuery.isSuccess &&
        (dataQuery.data.reports.length === 0 ? (
          <EmptyPaper message={"Nessun report ECG associato al paziente"} />
        ) : (
          <MaterialReactTable
            columns={tableColumns}
            data={dataQuery.data?.reports || []}
            initialState={{
              density: "compact",
              showColumnFilters: false,
            }}
            enablePagination={true}
            manualPagination
            rowCount={dataQuery.data?.total ?? 0}
            onPaginationChange={setPagination}
            state={{ pagination }}
            enableBottomToolbar={true}
            enableTopToolbar={false}
            enableSorting={false}
            muiTablePaperProps={{
              elevation: 0,
            }}
            muiTableContainerProps={{
              sx: {
                overflowX: "hidden",
              },
            }}
            enableColumnResizing
            enableColumnActions={false}
            enableRowSelection={false}
            enableRowActions={true}
            displayColumnDefOptions={{
              "mrt-row-actions": { header: "Report" },
            }}
            positionActionsColumn="last"
            renderRowActions={({ row, table }) => [
              // disabled={
              //   row.original.data.Duration === null ||
              //   row.original.data.Duration === undefined
              // }

              <IconButton
                key="view"
                onClick={() => {
                  handleOpenViewReport(row.original.id);
                }}
              >
                <ViewIcon color="primary" />
              </IconButton>,
            ]}
          />
        ))
      )}
    </main>
  );
}

export default ECGTab;
